import { Link } from "react-router-dom";
import { Phone, Envelope, Globe, InstagramLogo, MapPin, Download, ArrowLeft } from "@phosphor-icons/react";

const VCF = `BEGIN:VCARD
VERSION:3.0
FN:AJ "SlayJ"
N:Johnson;AJ;;;
ORG:Sweat With Slay
TITLE:Strength Coach · NASM · NFPT · CNC
EMAIL;TYPE=INTERNET:sweatwithslay@gmail.com
URL:https://sweatwithslay.com
URL;TYPE=INSTAGRAM:https://instagram.com/sweatwithslay
ADR;TYPE=WORK:;;Tampa;FL;;USA
NOTE:Obsessed with watching people win. Custom fitness coaching for busy humans.
END:VCARD`;

const CARD_URL = "https://sweatwithslay.com/card";
const QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(CARD_URL)}&bgcolor=ffffff&color=0A0A0A&margin=10`;

function downloadVCF() {
  const blob = new Blob([VCF], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = "SlayJ-SweatWithSlay.vcf";
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}

export default function Card() {
  return (
    <main data-testid="card-page" className="bg-[#0A0A0A] text-white font-body min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/50 hover:text-[#FF1B91] mb-8">
          <ArrowLeft size={14} weight="bold" /> Back to site
        </Link>
        <div className="border border-[#FF1B91] bg-[#0F0F0F] p-8 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-[#FF1B91]/20 blur-3xl pointer-events-none" />
          <div className="relative">
            <p className="text-[10px] uppercase tracking-[0.4em] text-[#FF1B91] font-bold mb-3">Digital Card</p>
            <h1 className="font-display font-black uppercase text-4xl tracking-tighter mb-1">AJ <span className="text-[#FF1B91]">"SlayJ"</span></h1>
            <p className="font-brush text-3xl text-[#FF1B91] -rotate-2 inline-block mb-6">Sweat With Slay</p>
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/55 font-semibold mb-8">Strength Coach · NASM · NFPT · CNC</p>

            <div className="space-y-3 mb-8 text-sm">
              <a href="mailto:sweatwithslay@gmail.com" data-testid="card-email" className="flex items-center gap-3 hover:text-[#FF1B91]"><Envelope size={18} weight="bold" className="text-[#FF1B91]" /> sweatwithslay@gmail.com</a>
              <a href="https://sweatwithslay.com" data-testid="card-site" className="flex items-center gap-3 hover:text-[#FF1B91]"><Globe size={18} weight="bold" className="text-[#FF1B91]" /> sweatwithslay.com</a>
              <a href="https://instagram.com/sweatwithslay" target="_blank" rel="noreferrer" data-testid="card-ig" className="flex items-center gap-3 hover:text-[#FF1B91]"><InstagramLogo size={18} weight="bold" className="text-[#FF1B91]" /> @sweatwithslay</a>
              <div className="flex items-center gap-3 text-white/65"><MapPin size={18} weight="bold" className="text-[#FF1B91]" /> Tampa · NY roots · Coaching everywhere</div>
            </div>

            <button onClick={downloadVCF} data-testid="card-save" className="w-full bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-5 py-4 text-xs font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink inline-flex items-center justify-center gap-3 mb-6">
              <Download size={14} weight="bold" /> Save to my contacts
            </button>

            <div className="border-t border-white/10 pt-6 flex items-center gap-5">
              <img src={QR_URL} alt="QR code to this card" className="w-24 h-24 border-2 border-white" data-testid="card-qr" />
              <div>
                <p className="text-[10px] uppercase tracking-[0.3em] text-white/45 font-bold mb-1">Scan to share</p>
                <p className="text-xs text-white/65 leading-snug">Point any phone camera at this QR — it'll open my card.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
